// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Docker_wrapper__3jSNj","childrenHolder":"Docker_childrenHolder__2znMg","dockChild":"Docker_dockChild__4Yfxe"};